import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form } from 'semantic-ui-react'

import SeguroPermite from '../../../components/funcionales/seguropermite'

//utils
import queries from '../../../utils/queries'
var moment = require('moment');

//Lista de Inflabs
const DetallePl = ({elemento, indice, handleChange}) => {
  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>
        <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkSeleccInf" checked={elemento.checkSeleccInf} onChange={(ev)=>handleChange(ev, indice)}/>
      </td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaCreate.substr(0, 10)}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numeroInflab}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.mecInflab}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ruta?elemento.ruta:0}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numeroOrden?elemento.numeroOrden:0}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ordenSAP?elemento.ordenSAP:''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrLubricante}</td>
    </tr>
  )
};
const ListaPl = ({list, handleChange}) => {
    const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} key={i} indice={i}
      handleChange={handleChange}/>);
    return(
      <tbody className=''>
        {nivel1Detalle}
      </tbody>
    )
  };

//FIN Lista de mecanismos

class LabEnvRecMue2 extends React.Component {
  state={list: 
    this.props.allInflabRtes.allInflabRtesRec?this.props.allInflabRtes.allInflabRtesRec.map((elemento, i) => ({
      ...elemento, checkSeleccInf: true})):[], 
      ingresa: 'S',
      permiteUpdate: true, confirmaAct: false, open: false, checkSeleccInfAll: true}

  crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        const {data} = await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  handleChange = async (ev, indice) => {
    this.setState({ingresa: 'N'})
    if(ev.target.name === "checkSeleccInfAll"){
      const list = this.state.list
      let checkSeleccInfAll = this.state.checkSeleccInfAll
      if(checkSeleccInfAll){
        checkSeleccInfAll = false
      }else{
        checkSeleccInfAll = true
      }
      for(let i=0; i<list.length; i++){
        list[i].checkSeleccInf = checkSeleccInfAll
      }
      this.setState({checkSeleccInfAll});
      this.setState({list});
    }

    if(ev.target.name === "checkSeleccInf"){
      const list = this.state.list
      let checkSeleccInfAll = this.state.checkSeleccInfAll
      list[indice].checkSeleccInf = ev.target.checked
      checkSeleccInfAll = false
      this.setState({checkSeleccInfAll});
      this.setState({list});
    }   
  }

  handleSubmit = async (ev, list1, opcion)=>{
    let list = await list1.filter(elemento => elemento.checkSeleccInf === true)

    if(list.length>0){
      document.body.style.cursor = 'wait'
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      for (let iiii=0;iiii<list.length;iiii++){
        let movColecc = []
        let argsUpd = {}
        if(opcion==='Sin enviar'){
          argsUpd = {
            "_id": list[iiii]._id,
            "tipoAct": 'EditarEnvLab',
            "estadoEnvio": 'Enviada',
            "fechaEnvioLab": fechaHoraHoy,
            "usuarioEnvioLab": localStorage.getItem('userLogin'),
          }
        }else{
          if(opcion==='Enviada'){
            argsUpd = {
              "_id": list[iiii]._id,
              "tipoAct": 'EditarRecLab',
              "estadoEnvio": 'Recibida',
              "fechaRecibeLab": fechaHoraHoy,
              "usuarioRecibeLab": localStorage.getItem('userLogin'),
            }
          }else{
            argsUpd = {
              "_id": list[iiii]._id,
              "tipoAct": 'EditarEnvCli',
              "estadoEnvio": 'Entregada',
              "fechaEnvioCliente": fechaHoraHoy,
              "usuarioEnvioCliente": localStorage.getItem('userLogin'),
            }          
          }        
        }
        movColecc.push(argsUpd)

        let numDocCRUD = 0
        let totDocCRUD = 1
        let argsCrud = []
        let crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editInflab)
        }

        argsCrud[numDocCRUD] = movColecc[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editInflab

        console.log(argsCrud)
        await this.updColecc(crudColecc, argsCrud, totDocCRUD)
      }
      document.body.style.cursor = 'default'
      await this.props.allInflabRtes.refetch()       

      this.setState({open: false, confirmaAct: false})
    }else{
      alert("!! No existen registros para enviar !!")
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){
      this.setState({open: true})
    }else{
      this.setState({open: false})
    };
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  componentDidMount(){
    if(this.props.allInflabRtesRec.allInflabRtes){
      if(this.props.allInflabRtesRec.allInflabRtes.length>0){
        let argsBuscar=""
        argsBuscar += `'estadoInflab': '${this.props.opcion2}', 'estadoEnvio': ${this.props.opcion}`
        let argsBuscarIl = {tipoqry: `[{$match: {${argsBuscar}}}]`}
        let list = this.props.allInflabRtesRec.refetch(argsBuscarIl)
       
        if(this.props.opcion==='Sin enviar'){
          list = list.filter(elemento => elemento.usuarioCreate===localStorage.getItem('userLogin'))
          list = list.map((elemento, i) => ({
            ...elemento, checkSeleccInf: true
          }))
        }
        
        this.setState({list, ingresa: 'N'}) 
      }
    }
  }

  async componentDidUpdate(prevProps){
    if((this.props.allInflabRtesRec.allInflabRtes&&prevProps.allInflabRtesRec.allInflabRtes) || this.state.ingresa==='S'){
      if((this.props.allInflabRtesRec.allInflabRtes!==prevProps.allInflabRtesRec.allInflabRtes)||!this.state.list){
        this.setState({list: 
          this.props.allInflabRtesRec.allInflabRtes?this.props.allInflabRtesRec.allInflabRtes.map((elemento, i) => ({
            ...elemento, checkSeleccInf: true
          })):[]
        })
        this.setState({checkSeleccInfAll: true});
      }
    }

    // if(this.state.ingresa==='S'){
    //   this.props.allInflabRtesRec.refetch()
    //   let list = this.props.allInflabRtesRec.allInflabRtes?this.props.allInflabRtesRec.allInflabRtes.map((elemento, i) => ({
    //     ...elemento, checkSeleccInf: true
    //   })):[]
    //   if(this.props.opcion==='Sin enviar'){
    //     list = list.filter(elemento => elemento.usuarioCreate===localStorage.getItem('userLogin'))
    //     list = list.map((elemento, i) => ({
    //       ...elemento, checkSeleccInf: true
    //     }))
    //   }
      
    //   this.setState({list, ingresa: 'N'}) 
    // }
  }

  render(){
    const {list, argsDocum, checkSeleccInfAll, permiteUpdate, confirmaAct, open} = this.state;
    // const a250110 = autorizacUA.findIndex( autorizac => autorizac === "250110" );
    let mensaje = ""
    if(this.props.opcion==='Sin enviar'){
      mensaje = "Enviar muestras al laboratorio"
    }
    if(this.props.opcion==='Enviada'){
      mensaje = "Recibir muestras en laboratorio"
    }
    if(this.props.opcion==='Recibida'){
      mensaje = "Enviar muestras al cliente"
    }
    let imgIcon = "images/documento_32.png"
    
    console.log(this.props.opcion, this.props.opcion2)
    console.log(list)

    return (
      // <div>
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, list, this.props.opcion):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" style={{left: '36em', width: '30%', paddingTop: '0.1em'}}>
                  <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
              </div>
            </div>
            <div>
              <div style={{height: '36em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>
                        <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkSeleccInfAll" checked={checkSeleccInfAll} onChange={this.handleChange}/>
                      </th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Fecha</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Reporte</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Informe</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Ruta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>OT LCM</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>OT SAP</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Empresa</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Planta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Sección</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Equipo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Componente</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Mecanismo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Lubricante</th>
                     </tr>
                  </thead>
                  <ListaPl list={list} handleChange={this.handleChange}/>
                </table>
                <p></p>
              </div>
            </div>
          </Form>
        </div>
      // </div>
    )
  }
};

export default compose(
  graphql(queries.query.allInflabRtes, {name:'allInflabRtes', 
  options: (props) => {return {variables: {tipoqry: `[{$match: {'estadoInflab': '${props.opcion2}', 'estadoEnvio': '${props.opcion}'}}]`}}}}),

  graphql(queries.query.allInflabRtes, {name:'allInflabRtesRec', 
    options: (props) => {return {variables: {tipoqry: `[{$match: {'estadoInflab': '${props.opcion2}', 'estadoEnvio': '${props.opcion}'}}]`}}}}),
  graphql(queries.query.allInflabRtes, {name:'allInflabRtesFin',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'estadoInflab': 'FINALIZADO', 'estadoEnvio': '${props.opcion}'}}]`}}}}),

  graphql(queries.mutation.editInflab, {name:'editInflab'}),
  graphql(queries.mutation.fecha, {name:'fecha'}),
)(LabEnvRecMue2) 
